import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appGuideAnchor]',
})
export class GuideAnchorDirective {
  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  @Input('appGuideAnchor')
  set guideAnchor(value: string | null | undefined) {
    const element = this.elementRef.nativeElement;

    if (value) {
      element.dataset.guideAnchor = value;
    } else {
      delete element.dataset.guideAnchor;
    }
  }
}
